/**
 * @generated SignedSource<<a96780ee69d78061b7f7933de5a400c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShareContentUnlockedArticle$data = {
  readonly entityId: string;
  readonly " $fragmentType": "useShareContentUnlockedArticle";
};
export type useShareContentUnlockedArticle$key = {
  readonly " $data"?: useShareContentUnlockedArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShareContentUnlockedArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useShareContentUnlockedArticle"
};

(node as any).hash = "a6f349b31c9f030ba2f31accdb89231a";

export default node;
